import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import SharedLayout from "../../layouts/shared-layout/SharedLayout";
import { useNotification } from "../../context/NotificationContext";
import CreativeStepsLayout from "./ClinicalTrialViewCards";

const ClinicalTrialView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { success, error } = useNotification();

  const handleCloseViewClinicalTrial = () => {
    navigate("/clinical-trial/list");
  };

  return (
    <SharedLayout
      formTitle="View Clinical Trial"
      onAddItem={() => {
        success("Clicked add");
      }}
      onCloseDetails={handleCloseViewClinicalTrial}
      animationSize="eighty"
      addPermission={["/auth/login"]}
      hideAdd={true}
    >
      <CreativeStepsLayout clinical_trial_id={parseInt(id || "0", 10)} />
    </SharedLayout>
  );
};

export default ClinicalTrialView;
